import React from 'react';

import Icon, { ColorVariant } from '@apigrowfinance/pbolt-icon';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { RiDraftLine, RiPhoneLine } from 'react-icons/ri';

import { ExtendedPanel } from '@components/operatorSession/usePanelSelected';

type CallButtonsProps = {
    onButtonClick: (openPanel: ExtendedPanel) => void;
    openPanel: ExtendedPanel;
};

const CallButtons = ({ onButtonClick, openPanel }: CallButtonsProps) => {
    const { theme } = useTheme();
    return (
        <>
            <Icon
                data-testid="notes-button"
                onClick={() => {
                    onButtonClick(openPanel === 'NOTES' ? 'CLOSED' : 'NOTES');
                }}
                colorVariant={ColorVariant.PaperMain}
                avatarProps={{
                    sx: {
                        height: theme.spacing(6),
                        width: theme.spacing(6),
                    },
                }}>
                <RiDraftLine />
            </Icon>
            <Icon
                data-testid="end-call-button"
                onClick={() => {
                    onButtonClick(openPanel === 'REPORT' ? 'CLOSED' : 'REPORT');
                }}
                avatarProps={{
                    sx: {
                        backgroundColor: 'background.paper',
                        color: theme.palette.error.main,
                        '&:hover *, &:focus *': {
                            color: theme.palette.error.main,
                        },
                        height: theme.spacing(6),
                        width: theme.spacing(6),
                    },
                }}>
                <RiPhoneLine />
            </Icon>
        </>
    );
};

export default CallButtons;
